
export class Client {
    Id: number = -1;
    Active: boolean;
    Title: string = '';
    FirstName: string = '';
    MiddleNames: string = '';
    LastName: string = '';
    MobileTelephone: string = '';
    WorkTelephone: string = '';
    HomeTelephone: string = '';
    EmailAddress: string = '';
    LoyaltyPoints: number;
    ClientNumber: string = '';
    Gender: string = '';
    SkinTypeId: number;
    DateOfBirth: Date;
    BranchEnrolled: number;
    Notes: string = '';
    UrgentNotes: string = '';
    EmergencyInfo: string = '';
    Address1: string = '';
    Address2: string = '';
    Address3: string = '';
    Address4: string = '';
    Address5: string = '';
    PostalCode: string = '';
    ContactByAddress: boolean;
    ContactByEmail: boolean;
    ContactByHomeTelephone: boolean;
    ContactByMobileTelephone: boolean;
    AllowOnlineBooking: boolean;
    IdChecked: boolean;
    IdCheckedDateTime: Date;
    NewOnlineClientWarningConfirmed: boolean;
    TerminalId: number;    
    BranchId: number;
    photo:string="";
    CourseDiscount:number=0;
    SessionDiscount:number=0;
    ProductDiscount:number=0;
    PreSessionDelay:number=null;
    PostSessionDelay:number=null;
    OutstandingCredits: number | string = null;

    static CreateFromClient(c: Client): Client {
        var client: Client = new Client();

        client.Id = c.Id;
        client.Active = c.Active;
        client.Title = c.Title;
        client.FirstName = c.FirstName;
        client.MiddleNames = c.MiddleNames;
        client.LastName = c.LastName;
        client.MobileTelephone = c.MobileTelephone;
        client.WorkTelephone = c.WorkTelephone;
        client.HomeTelephone = c.HomeTelephone;
        client.EmailAddress = c.EmailAddress;
        client.LoyaltyPoints = c.LoyaltyPoints;
        client.ClientNumber = c.ClientNumber;
        client.SkinTypeId = c.SkinTypeId;
        client.Gender = c.Gender;
        client.DateOfBirth = c.DateOfBirth;
        client.BranchEnrolled = c.BranchEnrolled;
        client.Notes = c.Notes;
        client.UrgentNotes = c.UrgentNotes;
        client.EmergencyInfo = c.EmergencyInfo;
        client.Address1 = c.Address1;
        client.Address2 = c.Address2;
        client.Address3 = c.Address3;
        client.Address4 = c.Address4;
        client.Address5 = c.Address5;
        client.PostalCode = c.PostalCode;
        client.ContactByAddress = c.ContactByAddress;
        client.ContactByEmail = c.ContactByEmail;
        client.ContactByHomeTelephone = c.ContactByHomeTelephone;
        client.ContactByMobileTelephone = c.ContactByMobileTelephone;
        client.AllowOnlineBooking = c.AllowOnlineBooking;
        client.IdChecked = c.IdChecked;
        client.IdCheckedDateTime = c.IdCheckedDateTime;
        client.NewOnlineClientWarningConfirmed = c.NewOnlineClientWarningConfirmed;
        client.TerminalId = c.TerminalId;
        client.BranchId = c.BranchId;
        client.photo=c.photo;
        client.CourseDiscount=c.CourseDiscount;
        client.SessionDiscount=c.SessionDiscount;
        client.ProductDiscount=c.ProductDiscount;        
        client.PreSessionDelay=c.PreSessionDelay;
        client.PostSessionDelay=c.PostSessionDelay;
        client.OutstandingCredits = c.OutstandingCredits;
        return client;
    }

}
